import type { KAPLAYCtx } from '../../types.ts'
import pt from './langs/pt.ts'
import en from './langs/en.ts'

export function useLang(k: KAPLAYCtx) {
  const data = { pt, en }

  function getLangString(key: string) {
    if ( !data.hasOwnProperty(k.store.currLang) || !data[k.store.currLang].hasOwnProperty(key))
      return `Error: No translation.`

    return data[k.store.currLang][key]
  }

  return {
    getLangString,
  }
}
